import { Component } from '@theme/component';

const DRAG_THRESHOLD = 4;

class AtelierDrawerCarousel extends Component {
  requiredRefs = ['track'];

  #dragging = false;
  #captured = false;
  #pointerId = null;
  #startX = 0;
  #startScroll = 0;
  #moved = false;
  #lastFocus = null;

  connectedCallback() {
    super.connectedCallback();
    const track = this.refs.track;
    track.addEventListener('pointerdown', this.#onDown);
    track.addEventListener('pointermove', this.#onMove);
    track.addEventListener('pointerup', this.#onUp);
    track.addEventListener('pointercancel', this.#onUp);
    track.addEventListener('dragstart', this.#preventDrag);
    this.addEventListener('click', this.#onClick);
    document.addEventListener('keydown', this.#onKey);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('keydown', this.#onKey);
  }

  #onDown = (event) => {
    this.#moved = false;
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    this.#dragging = true;
    this.#pointerId = event.pointerId;
    this.#startX = event.clientX;
    this.#startScroll = this.refs.track.scrollLeft;
  };

  #onMove = (event) => {
    if (!this.#dragging) return;
    const delta = event.clientX - this.#startX;
    if (!this.#moved) {
      if (Math.abs(delta) <= DRAG_THRESHOLD) return;
      this.#moved = true;
      this.#captured = true;
      this.refs.track.setPointerCapture?.(event.pointerId);
      this.refs.track.classList.add('is-dragging');
    }
    this.refs.track.scrollLeft = this.#startScroll - delta;
  };

  #onUp = () => {
    if (this.#captured) {
      this.refs.track.releasePointerCapture?.(this.#pointerId);
      this.refs.track.classList.remove('is-dragging');
    }
    this.#dragging = false;
    this.#captured = false;
    this.#pointerId = null;
  };

  #preventDrag = (event) => {
    event.preventDefault();
  };

  #onClick = (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      if (this.#moved) return;
      this.#open(opener.getAttribute('data-drawer-open'), opener);
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      this.#close();
    }
  };

  #onKey = (event) => {
    if (event.key === 'Escape' && this.classList.contains('is-drawer-open')) this.#close();
  };

  #open(id, opener) {
    const drawer = this.querySelector(`[data-drawer="${id}"]`);
    if (!drawer) return;
    this.#lastFocus = opener;
    this.querySelectorAll('[data-drawer]').forEach((d) => d.classList.remove('is-active'));
    drawer.classList.add('is-active');
    this.classList.add('is-drawer-open');
    const close = drawer.querySelector('[data-drawer-close]');
    close?.focus();
  }

  #close() {
    this.classList.remove('is-drawer-open');
    this.querySelectorAll('[data-drawer]').forEach((d) => d.classList.remove('is-active'));
    this.#lastFocus?.focus();
  }
}

if (!customElements.get('atelier-drawer-carousel')) {
  customElements.define('atelier-drawer-carousel', AtelierDrawerCarousel);
}
